import { Routes } from '@angular/router';
import { ERoutes } from '../../types/app-routes';

export const docRegistrationRoutes: Routes = [
  {
    path: ERoutes.DOC_REGISTRATION,
    loadComponent: () =>
      import('./doc-registration-card/doc-registration-card.component').then(
        (m) => m.DocRegistrationCardComponent
      ),
  },
];
